export default __webpack_public_path__ + "static/media/projectTimeline.e85cfae7.svg";